import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
//services
import {
  createSession,
  getMatchedAvailabilites,
  getPractitionars,
  getPractitionarInfo,
  getPractitionarsFilter,
  saveDirectAdvanceBooking,
  saveSessionTerms,
  getSessionLimit,
  getMediumServiceDetails,
  saveUserTracks,
} from "../../../services/client";

import { Link, useNavigate } from "react-router-dom";
import Loader from "./loader/loader";
import { useDispatch, useSelector } from "react-redux";
import {
  setLoading,
  setLoadingContent,
  setLoadingText,
} from "../../../reducer/auth/auth";
import {
  setMediumData,
  setSaveTermsHanlder,
  setSaveTermsHanlderStarter,
} from "../../../reducer/userSlice";

import {
  setmediumListItems,
  setbookingBtnStatus,
  setbookedAppointmentData,
  setClientPathArray,
  setBookingTime,
  setBookingDate,
  setWindowObject,
  setRenderTypeInfo,
  setBookingTypeInfo,
} from "../../../reducer/clientsSlice";
import Pusher from "pusher-js";

//component
import Progress from "./Progress";
import AdvanceAppointment from "./advanceappointment";
import Practitioners from "./premiumsessions/practitioners";
import PractitionersMain from "./premiumsessions/practitioners/indexnew";
import PractitionerInfo from "./premiumsessions/practitonerInfo";
import useFavoriteToggle from "./premiumsessions/useFavoriteToggle";
import OpenUrlPopUp from "../../../layout/openUrlPopUp";
import { changeOnlineStatusFunc } from "../../../commonfunctions";
import Questions from "./questions";
import { getLanguages, getSpeciality } from "../../../services/uidata";
import StepOne from "./bookasessionlaterquestions/stepone";
import StepTwo from "./bookasessionlaterquestions/steptwo";
import { getBannerPage } from "../../../services/client";
import Button from "../../../components/button";
import { toast } from "react-toastify";
import { getCreateAppointmentSubseesions } from "../../../services/client";
import BackFillCheck from "./backfillpopup";
import immediateOnDemandRealtime from "../../../services/immediateOnDemandRealtime";
import { buildMatchingCriteria } from "../../common/immediateOnDemand/matchingUtils";
import ConfirmImmediateSession from "../../admin/appointments/subcomponents/cancelimmediatesessionpopup";
import StarterVideoOneTimeWatch from "./startervideoonetimewatch";
import DonatedBookingQuestion from "./bookasessionlaterquestions/DonatedBookingQuestion";
import StarterQuestions from "./starterQuestions";
import QuestionsStarter from "./questionsStarter";
import AboutReviewModal from "./aboutreviewmodal";
import { useLocation } from "react-router-dom";
import Footer from "./footer";
import {
  canShowDonatedBookingOption,
  canShowStarterBookingOption,
  canShowImmediateSessionOption,
  clearStarterBookingDraft,
  hasBlockedStarterBookingDraft,
  isStarterBookingBlocked,
} from "./starterBooking";

export default function ClientAppointment() {
  const auth = useSelector((state) => state.user);
  const {
    preferences,
    bookingdate,
    bookingtime,
    bookingIds,
    windowObject,
    mediumsToBeMatch,
    renderTypeInfo,
    bookingTypeInfo,
  } = useSelector((state) => state.client);
  const { promotion_code, is_starter, appointmentCount, starter_user_survey } =
    useSelector((state) => state.user.user);
  const { is_guest_client } = useSelector((state) => state.user.user);
  const blockedStarterBooking = isStarterBookingBlocked(auth.user);
  const canShowStarterOption = canShowStarterBookingOption(auth.user);
  // const { appointment_count } = useSelector((state) => state.user.user);
  // const {languages ,specialities ,countries } = preferences
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [renderType, setRenderType] = useState("loader");
  // const [appointmentType, setAppointmentType] = useState("");
  // const [mediumStatus, checkMediumStatus] = useState(false);
  // const [loaderLine, setLoaderLine] = useState(0);
  const [saveterms, setSaveTerms] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [isPaused, setIsPaused] = useState(true);
  const [time, setTime] = useState(0);
  const [practitioners, setPractitioners] = useState([]);
  // True while the initial medium list is being fetched, so the list screen
  // shows its loader instead of an empty grid.
  const [practitionersLoading, setPractitionersLoading] = useState(false);
  const [practitionerInfo, setPractitionerInfo] = useState(null);
  // Set when the client arrived from the favourites page's Book Now. Holds the
  // medium they picked and the service payload the duration popup already
  // fetched, so the checklist can be shown first and the calendar opened after
  // it without a second round trip.
  const [favoriteBooking, setFavoriteBooking] = useState(null);
  const [step, setStep] = useState(0);
  const [limit, setLimit] = useState(0);
  const [loaderType, setLoaderType] = useState("image");
  const [redirelUrl, setRedirelUrl] = useState(null);
  // const [stopTime, setstopTime] = useState(false);
  const [bookedId, setbookedId] = useState("");
  const [howManyTime, setHowManyTime] = useState(0);
  const [formLanguages, setFormLanguages] = useState([]);
  const [specialtyData, setSpecialityData] = useState([]);
  const [showBtn, setShowBtn] = useState(false);
  const [bookInfo, setBookInfo] = useState("");
  const [sessionType, setSessionType] = useState("prof");
  const [bannerLimit, setBannerLimit] = useState(0);
  const [bannerDesc, setBannerDesc] = useState("");
  const [checkOriganalType, setcheckOriganalType] = useState("original");
  const [bookingType, setBookingType] = useState("");

  const [appointmentTyepList, setAppointmentTyepList] = useState([]);
  const [mediumSessionInfo, setMediumSessionInfo] = useState();
  const [activeSessionId, setActiveSessionId] = useState("");
  const [activeSubSessionId, setActiveSubSessionId] = useState(""); //
  const [activeDurationId, setActiveDurationId] = useState("");
  const [activeAmount, setActiveAmount] = useState("");
  const [activeCurrency, setActiveCurrency] = useState("");
  const [activesession_id, setactivesession_id] = useState("5"); //
  const [appointment_count, setappointment_count] = useState(true);
  const canShowDonatedOption = canShowDonatedBookingOption(appointment_count);
  const canUseImmediateSession = canShowImmediateSessionOption(auth.user);
  const [backupRenderType, setBackUpRenderType] = useState("");
  const [glowStarterType, setGlowStarterType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  const openDonatedCalendarFromImmediateExit = () => {
    setActiveSessionId("5");
    setactivesession_id("5");
    setActiveSubSessionId("");
    setActiveDurationId("");
    setActiveAmount("");
    setActiveCurrency("");
    setBookingType("outreach");
    setcheckOriganalType("dummy");
    localStorage.setItem("activesession_id", "5");
    localStorage.setItem("type", "newappointment");
    localStorage.removeItem("subsession_id");
    localStorage.removeItem("duration");
    localStorage.removeItem("amount");
    localStorage.removeItem("activeCurrency");
    setRenderType("newappointment");
  };

  useEffect(() => {
    const existingSessionId = localStorage.getItem("session_id");

    if (!existingSessionId) {
      const timeoutId = setTimeout(() => {
        console.log(existingSessionId, "localStorage.getItem(");
        let body = {
          new_appointment_btn_clicked: "yes",
        };

        saveUserTracks(body)
          .then((data) => {
            if (data.data.status) {
              localStorage.setItem("session_id", data.data.data.session_id);
            }
          })
          .catch(() => {});
      }, 500);

      return () => clearTimeout(timeoutId); // Cleanup function
    }
  }, []);
  useEffect(() => {
    dispatch(setLoading(true));
    getSessionLimit()
      .then((data) => {
        if (data.data.status) {
          setappointment_count(data.data.data.appointment_count);
        }
        setTimeout(() => {
          dispatch(setLoading(false));
        }, 300);
      })
      .catch(() => {
        dispatch(setLoading(false));
      });

    const params = new URLSearchParams(location.search);
    const from = params.get("from");
    const booking = params.get("booking");

    if (from === "favorites-profile") {
      // Handed off from the favourites page: open this medium's profile. Ahead
      // of the resume branches so a leftover half-finished booking cannot
      // swallow the link the client just clicked.
      openMediumProfileFromHandOff(params.get("selectedMediumId"));
    } else if (from === "favorites-book") {
      // Book Now on the favourites page. The medium and duration are already
      // chosen, but the professional checklist still has to be answered, so it
      // goes there first and the calendar opens once it is submitted.
      startFavoriteBooking();
    } else if (from === "favorites-browse") {
      // "Browse Professional Mediums" on the favourites page. The client has
      // already said they want a professional session by being on that page, so
      // start the professional journey - the pro checklist, then the medium list
      // - instead of asking them to pick an appointment type again.
      //
      // Ahead of the resume branches for the same reason as above: a leftover
      // half-finished booking must not swallow the button they just pressed.
      startProfessionalJourney();
    } else if (from === "immediate-session-exit" && booking === "donated") {
      openDonatedCalendarFromImmediateExit();
    } else if (
      blockedStarterBooking &&
      hasBlockedStarterBookingDraft({
        type: localStorage.getItem("type"),
        activesession_id: localStorage.getItem("activesession_id"),
      })
    ) {
      clearStarterBookingDraft();
      setRenderType("select");
      setBookingType("");
      setactivesession_id("5");
      toast.error(
        "Starter session booking is not available for your account.",
        {
          position: "top-center",
        }
      );
    } else if (localStorage.getItem("type") === "newappointment") {
      setActiveSubSessionId(localStorage.getItem("subsession_id"));
      setActiveDurationId(localStorage.getItem("duration"));
      setActiveAmount(localStorage.getItem("amount"));
      setActiveCurrency(localStorage.getItem("activeCurrency"));
      setRenderType("newappointment");
      setBookingType("outreach");
      setactivesession_id(localStorage.getItem("activesession_id"));
    } else {
      let bookingFrom = localStorage.getItem("bookingFrom");
      console.log(bookingFrom);
      if (bookingFrom == "medium") {
        startProfessionalJourney();
        localStorage.removeItem("bookingFrom");
        localStorage.setItem("bookingFrom", "removed");
      }

      if (bookingFrom && bookingFrom == "removed") {
        navigate("/booking");
      }
      if (!bookingFrom) {
        setRenderType("select");
      }
    }
    dispatch(setWindowObject(true));
    // setRenderType("newappointment");

    if (formLanguages.length === 0) updateLanguage();
    if (specialtyData.length === 0) updateSpeciality();
    getBanner();
    // window.loadModal2("#OpenUrlPopUp", "show");
    // callProfile();
    dispatch(setClientPathArray("appointment"));

    if (
      renderTypeInfo === "startBookaSessionLaterQuestions" &&
      bookingTypeInfo === "outreach"
    ) {
      setRenderType("startBookaSessionLaterQuestions");
      setBookingType("outreach");
      setcheckOriganalType("dummy");
      // dispatch(setRenderTypeInfo(''))
      // dispatch(setBookingTypeInfo(''))
    }
    if (
      renderTypeInfo === "book-specific-professinal" &&
      bookingTypeInfo === "professional"
    ) {
      setRenderType("book-specific-professinal");
      setBookingType("professional");
      // dispatch(setRenderTypeInfo(''))
      // dispatch(setBookingTypeInfo(''))
    }
    return () => {
      setClientPathArray(null);
    };
  }, [blockedStarterBooking]);

  useEffect(() => {
    dispatch(setBookingTypeInfo(bookingType));
    dispatch(setRenderTypeInfo(renderType));
  }, [renderType]);

  const getBanner = () => {
    getBannerPage()
      .then((data) => {
        if (data.data.status) {
          let info = data.data.data[0];
          setBannerLimit(parseInt(info.status));
          setBannerDesc(info.description);
        }
      })
      .catch(() => {});
  };
  const updateLanguage = () => {
    getLanguages()
      .then((data) => {
        setFormLanguages(data.data.data);
      })
      .catch((err) => console.log(err));
  };
  const updateSpeciality = () => {
    getSpeciality()
      .then((data) => {
        setSpecialityData(data.data.data);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    Pusher.logToConsole = false;
    var pusher = new Pusher("823ab72ed6ecd563b8c8", {
      cluster: "ap2",
    });

    var channel = pusher.subscribe("notify-clients");
    channel.bind("App\\Events\\NotifyClients", function (data) {
      // checkMediumStatus(!data.medium ? true : false);
      if (!data.medium) {
        if (parseInt(bookedId) === parseInt(data.appointment_id)) {
          // setstopTime(true);
          changeOnlineStatusFunc(0, dispatch);
          setHowManyTime(0);
          setRenderType("loader");
          setLoaderType("video");
          setRedirelUrl(data.link);
          handleReset();
          setIsActive(false);
        } else {
          console.log("inside else");
        }
      } else {
        console.log("main else");
      }
    });
  }, [bookedId]);

  useEffect(() => {
    if (howManyTime === 4) {
      if (renderType === "loader") {
        setRenderType("select");
        handleReset();
        setIsActive(false);
        window.openModal2();
      }
    }
  }, [howManyTime]);
  const setAppointments = (type) => {
    setRenderType(type);
    startSession(type);
  };
  // const selectAppointmentType = (type) => {
  //   setAppointmentType(type);
  // };
  const startSession = (type) => {
    updateSession(type);
  };

  const updateSession = (type) => {
    let support_date = new Date();
    // let lang = item.languages.map((item) => {
    //   return item.id;
    // });
    let body = {
      time: moment.utc().add(4, "minutes").format("HH:mm"),
      date: moment.utc(support_date).format("YYYY-MM-DD HH:mm"),
      ondemand: "no",
      offset: step,
      limit: limit === 0 ? 5 : limit,
      id: bookedId,
    };
    createSession(body)
      .then((data) => {
        if (data.data.status) {
          setbookedId(data.data.data.id);

          let lim = limit;
          // let steps = step;
          let tim = howManyTime;

          setHowManyTime(tim + 1);
          setLimit(lim === 0 ? 5 : lim + 5);
          setStep(lim === 5 ? 10 : 5);
          setTimeout(() => {
            if (type === "loader") {
              handleReset();
              // window.openModal2();
            }
          }, 900);
          dispatch(setMediumData(data.data.data));
        }
        if (!data.data.status) {
          handleReset();
          setIsActive(false);
          window.openModal2();
        }
      })
      .catch((err) => console.log(err));
  };
  const changeRender = () => {
    localStorage.removeItem("type");
    localStorage.removeItem("subsession_id");
    localStorage.removeItem("duration");
    localStorage.removeItem("amount");
    localStorage.removeItem("activeCurrency");
    localStorage.removeItem("activesession_id");

    const params = new URLSearchParams(location.search);
    const from = params.get("from");
    const mediumId = params.get("selectedMediumId");

    if (from === "coach-reviews") {
      sessionStorage.removeItem("userDataInfo");
      navigate("/booking");
    }
    if (bookingType === "professional") {
      setRenderType("premium-session");
    } else {
      setRenderType("select");
    }
    dispatch(setBookingTime(""));
    dispatch(setBookingDate(""));
    localStorage.setItem("settingAppointment", "No");
    // dispatch(setAppointment("No"));

    // navigate("/appointments");
  };

  const bookNewAppointment = () => {
    // changeRender()
    setRenderType("select");
    window.openModal2();
  };
  const startBookingAgain = () => {
    startLoaderNow();
    window.openModal2();
  };
  const getSessionTerms = (data) => {
    dispatch(setLoading(true));
    let body;

    if (activesession_id === "3") {
      body = {
        terms_and_condition_starter: JSON.stringify(data),
      };
    } else {
      body = {
        terms_and_condition_json: JSON.stringify(data),
      };
    }
    saveSessionTerms(body)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          if (activesession_id === "3") {
            dispatch(setSaveTermsHanlderStarter());
          } else {
            dispatch(setSaveTermsHanlder());
          }
          console.log("success");
        }
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };

  const getAvailabilites = () => {
    dispatch(
      setLoadingContent(
        `<div>Searching for availability... we'll have the results shortly! </div>`
      )
    );
    dispatch(setLoadingText(true));
    let body = {
      date: preferences.bookingdate,
      time: preferences.bookingtime,
    };

    getMatchedAvailabilites(body)
      .then((data) => {
        dispatch(setLoadingContent(``));
        dispatch(setLoadingText(false));
        if (data.data.status) {
          dispatch(setmediumListItems(data.data.data));
          dispatch(setbookingBtnStatus(true));
        }
        if (!data.data.status) {
          dispatch(setmediumListItems(data.data.data));
        }
        if (!data.data.status && data.data.message === "No Time Slots found") {
          dispatch(setmediumListItems(data.data.data));
          window.loadModal("#noslotsfound", "open");
        }
      })
      .catch((err) => {
        dispatch(setLoadingContent(``));
        dispatch(setLoadingText(false));
        console.log(err);
      });
  };
  const bookAppointment = () => {
    let amount =
      practitionerInfo !== null
        ? practitionerInfo.general.session_length !== undefined &&
          practitionerInfo.general.session_length !== "" &&
          practitionerInfo.general.session_length !== null
          ? Object.values(
              JSON.parse(practitionerInfo.general.session_length)
            )[0]
          : 20
        : 0;
    let currency =
      practitionerInfo !== null
        ? practitionerInfo.general.session_currency !== undefined &&
          practitionerInfo.general.session_currency !== "" &&
          practitionerInfo.general.session_currency !== null
          ? Object.values(
              JSON.parse(practitionerInfo.general.session_currency)
            )[0]
          : "CAD"
        : "";
    let medium_id =
      practitionerInfo !== null && practitionerInfo !== undefined
        ? practitionerInfo.general.medium_id
        : "";
    // dispatch(setLoading(true));
    let data = activesession_id;
    // let medium = selectedMedium.id;
    // getZoom(medium)
    //   .then((data) => {
    //     dispatch(setLoading(false));
    //     if (data.data.status) {
    if (practitionerInfo !== null && practitionerInfo !== undefined) {
      if (practitionerInfo.general.payStatus !== undefined) {
        if (practitionerInfo.general.payStatus === "before") {
          data = "8";
        } else {
          data = "7";
        }
      } else {
        if (
          (practitionerInfo.general.payType.includes(1) &&
            practitionerInfo.general.payType.includes(2)) ||
          (practitionerInfo.general.payType.length === 1 &&
            practitionerInfo.general.payType.includes(1)) ||
          practitionerInfo.general.payType.length === 0
        ) {
          data = "8";
        } else if (
          practitionerInfo.general.payType.length === 1 &&
          practitionerInfo.general.payType.includes(2)
        ) {
          data = "7";
        }
      }
    }
    startAdvanceBooking(medium_id, data, amount, currency);
    //   }
    // })
    // .catch(() => {
    //   dispatch(setLoading(false));
    // });
  };
  const startAdvanceBooking = (medium_id, data, amount, currency) => {
    console.log(activeSubSessionId, "activeSubSessionId");
    let body = {
      date: bookingdate,
      time: bookingtime,
      session_type: data,
      medium_id: medium_id,
      mediums: mediumsToBeMatch,
      amount: activeAmount === null ? "" : activeAmount,
      currency: activeCurrency === null ? "" : activeCurrency,
      duration: activeDurationId === null ? "" : activeDurationId,
      subsession_id: activeSubSessionId === null ? "" : activeSubSessionId,
    };
    if (bookingdate === "" || bookingtime === "") {
      toast.error("Please select both date and time slot", {
        position: "top-center",
      });
      dispatch(setLoading(false));
      return;
    }
    dispatch(
      setLoadingContent(" <div>We are finding the best Medium for you</div>")
    );
    dispatch(setLoadingText(true));
    saveDirectAdvanceBooking(body)
      .then((data) => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(""));
        if (data.data.status) {
          // localStorage.removeItem('type');
          dispatch(setbookedAppointmentData(data.data.data));
          console.log(data.data.data, "(data.data.data");
          window.loadModal("#advanceConfirmbooking", "open");
          localStorage.removeItem("subsession_id");
          localStorage.removeItem("duration");
          localStorage.removeItem("amount");
          localStorage.removeItem("activeCurrency");
          localStorage.removeItem("activesession_id");

          if (bookingType == "outreach") {
            let body = {
              session_id: localStorage.getItem("session_id"),
              newappointment_id: data.data.data.appointment_id,
            };
            saveUserTracksHandler(body);
            setTimeout(() => {
              localStorage.removeItem("session_id");
            }, 500);
          }
        }
        // if (
        //   !data.data.status &&
        //   data.data.message !== "Please hit the api again"
        // ) {
        //   window.loadModal("#noslotsfound", "open");
        // }
        // if (
        //   !data.data.status &&
        //   data.data.message === "Please hit the api again"
        // ) {
        //   startAdvanceBooking();
        // }
        if (!data.data.status) {
          let date = bookingdate;
          dispatch(setBookingDate(""));
          dispatch(setBookingDate(date));
          console.log(date);
          toast.error(data.data.message, {
            position: "top-center",
          });
        }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(""));
      });
  };
  const startLoaderNow = () => {
    changeOnlineStatusFunc(1, dispatch);
    setAppointments("loader");
    handleStart();
  };
  // const stopTimer = (interval) => {
  //   clearInterval(setLoaderLine(0));
  // };
  useEffect(() => {
    if (parseInt(time) === 117 && parseInt(howManyTime) === 3) {
      let tim = howManyTime;
      setHowManyTime(tim + 1);
    }
    if (parseInt(time) === 60 && howManyTime === 1) {
      handleReset();
      updateSession("loader");
    }
    if (parseInt(time) === 120) {
      handleReset();
      updateSession("loader");
    }
  }, [time]);
  useEffect(() => {
    let interval = null;

    if (isActive && isPaused === false) {
      interval = setInterval(() => {
        setTime((time) => time + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [isActive, isPaused]);

  const handleStart = () => {
    setIsActive(true);
    setIsPaused(false);
  };

  // const handlePauseResume = () => {
  //   setIsPaused(!isPaused);
  // };

  const handleReset = () => {
    // setIsActive(false);
    setTime(0);
  };
  const getPractitionarsList = () => {
    const hasShownModal = localStorage.getItem("aboutReviewModalShown");

    if (showPopup) {
      // Show modal only once
      window.loadModal2("#aboutReviewModal", "show");

      // Store flag in localStorage so it won’t show again
      localStorage.setItem("aboutReviewModalShown", "true");
      setShowPopup(false);
    }

    // setBookingType("professional");
    // setSessionType("prof");
    setPractitionersLoading(true);
    setRenderType("premium-session");
    getPractitionars()
      .then((data) => {
        if (data.data.status) {
          setPractitioners(data.data.data);
        }
        if (!data.data.status) {
          setPractitioners([]);
          // window.openModal2();
        }
      })
      .catch(() => {})
      .finally(() => setPractitionersLoading(false));
  };
  // Only the most recent filter request may update the list. Typing "Test",
  // clearing it, then typing "Gaurav" fires several requests; the slow ones
  // (an empty name returns every medium) used to land last and overwrite the
  // correct result. Each new call aborts the previous one, and a response that
  // is no longer the latest is ignored.
  const filterRequestRef = useRef({ id: 0, controller: null });
  const getPractitionarFiltersList = async (body) => {
    if (filterRequestRef.current.controller) {
      filterRequestRef.current.controller.abort();
    }
    const controller = new AbortController();
    const id = filterRequestRef.current.id + 1;
    filterRequestRef.current = { id, controller };

    const res = await getPractitionarsFilter(body, controller.signal);

    // Superseded by a newer request - leave the list alone.
    if (id !== filterRequestRef.current.id) return false;
    filterRequestRef.current.controller = null;

    if (res && res.data && res.data.status) {
      setPractitioners(res.data.data);
    } else {
      setPractitioners([]);
    }
    return true;
  };
  // Favourites are a client-only feature; usertype arrives loosely typed from the
  // API, so compare loosely.
  const canFavorite = auth.user && auth.user.usertype == 3;

  const FAVORITE_BOOKING_KEY = "favoriteBooking";

  const clearFavoriteBooking = () => {
    sessionStorage.removeItem(FAVORITE_BOOKING_KEY);
    setFavoriteBooking(null);
  };

  /**
   * Book Now hand-off from the favourites page.
   *
   * The medium and the duration are already chosen, but the professional
   * checklist still has to be answered, so this lands on the checklist and
   * finishFavoriteBooking() opens the calendar once it is submitted.
   *
   * The choice lives in sessionStorage rather than component state so it
   * survives a reload part-way through the checklist.
   */
  const startFavoriteBooking = () => {
    let pending = null;
    try {
      pending = JSON.parse(sessionStorage.getItem(FAVORITE_BOOKING_KEY));
    } catch (e) {
      pending = null;
    }

    // Remember the choice first, so the checklist's submit opens the calendar
    // for this medium instead of listing mediums. With no stash - a pasted URL,
    // or one already consumed - this is just the normal professional journey.
    if (pending && pending.medium) {
      setFavoriteBooking(pending);
    }

    // Deliberately the same entry point the appointment process uses, rather
    // than a copy of it: same booking-type tracking, same terms gate (checklist
    // straight away, or StepOne first when terms are not yet accepted). Copying
    // it would only let the two drift.
    startProfessionalJourney();
  };

  /**
   * What the professional checklist runs instead of listing mediums, when the
   * client already picked one on the favourites page: straight to the calendar
   * for that medium and that duration.
   *
   * Mirrors the ?from=coach-reviews pick-up in practitioners/indexnew.js, minus
   * the fetch - the duration popup already had this payload.
   */
  const finishFavoriteBooking = () => {
    const pending = favoriteBooking;

    if (!pending || !pending.service || !pending.service.info) {
      // Nothing to open a calendar with; the medium list is the safe landing.
      getPractitionarsList();
      return;
    }

    const options = pending.service.info;
    const chosen =
      options.find(
        (option) =>
          String(option.subsession_id) === String(pending.medium.subsession_id)
      ) || options[0];

    getSubsessions(
      options,
      chosen.subsession_id,
      chosen.forTwo != 0 ? chosen.duration + "2" : chosen.duration,
      chosen.price,
      chosen.currency
    );
    setPractitionerInfo({ general: { ...pending.medium } });
    setRenderType("newappointment");

    // Only the stash goes; the in-memory flag stays for the rest of this visit
    // so Cancel anywhere further on still returns to the favourites page.
    sessionStorage.removeItem(FAVORITE_BOOKING_KEY);
  };

  /**
   * Pick-up for the favourites page's View Profile hand-off. The professional
   * profile only exists here, as renderType "book-a-session".
   *
   * The favourites page fetches the profile before it navigates and leaves it in
   * sessionStorage, so the profile paints on this first render. Without it we
   * would sit on renderType "loader" - the booking journey's search.gif and its
   * "watch this 3-minute video" caption - until a fetch came back, which is not
   * a page anyone should see on the way to a profile.
   */
  const openMediumProfileFromHandOff = (mediumId) => {
    const handedOver = sessionStorage.getItem("favoriteProfileInfo");
    sessionStorage.removeItem("favoriteProfileInfo");

    setBookingType("professional");
    setSessionType("prof");
    setactivesession_id("5");

    if (handedOver) {
      try {
        setPractitionerInfo(JSON.parse(handedOver));
        setRenderType("book-a-session");
        return;
      } catch (e) {
        // Unreadable stash - fall through and fetch it here instead.
      }
    }

    // No stash: a pasted or reloaded URL. Slower, and it does show the loader,
    // but it still lands on the right page.
    if (!mediumId) {
      setRenderType("select");
      return;
    }
    bookSession(mediumId);
  };

  const { toggleFavorite: toggleFavoriteHandler, favoritePendingId } =
    useFavoriteToggle((mediumId, value) => {
      setPractitioners((list) =>
        list.map((medium) =>
          medium.medium_id === mediumId
            ? { ...medium, is_favorite: value }
            : medium
        )
      );
      // The profile page reads the same flag off `general`, and Back from it
      // only flips renderType - the list is never refetched. So both copies have
      // to move together or whichever screen you return to shows a stale heart.
      setPractitionerInfo((info) =>
        info && info.general && info.general.medium_id === mediumId
          ? { ...info, general: { ...info.general, is_favorite: value } }
          : info
      );
    });

  const bookSession = (id) => {
    getPractitionarInfo(id)
      .then((data) => {
        if (data.data.status) {
          setPractitionerInfo(data.data.data);
          setRenderType("book-a-session");
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        } else {
          toast.error("Please Try again Error while fetching data", {
            position: "top-center",
          });
        }
      })
      .catch(() => {});
  };
  const onVideoEnd = () => {
    setTimeout(() => {
      // window.open(redirelUrl);
      window.loadModal2("#OpenUrlPopUp", "show");
      setTimeout(() => {
        window.loadModal2("#OpenUrlPopUp", "hide");
        navigate("/appointments");
        window.location.reload();
      }, 240000);
      // window.location.href = redirelUrl;
      // window.open(redirelUrl, "_blank");
    }, 2000);
  };

  const backHandler = () => {
    let bookingFrom = localStorage.getItem("bookingFrom");
    if (bookingFrom) {
      navigate("/booking");
    } else {
      setRenderType("premium-session");
      setRenderType("select");
    }
  };

  const onCancelQuestions = () => {
    if (bookingType == "outreach") {
      let body = {
        session_id: localStorage.getItem("session_id"),
        back_btn_clicked: "yes",
      };
      saveUserTracksHandler(body);
    }

    if (favoriteBooking) {
      // Came in from the favourites page - send them back where they started.
      clearFavoriteBooking();
      navigate("/favorite-mediums");
      return;
    }
    let bookingFrom = localStorage.getItem("bookingFrom");
    if (bookingFrom === "medium" || bookingFrom === "removed") {
      localStorage.removeItem("bookingFrom");
      navigate("/service-entry");
    } else if (bookingFrom) {
      navigate("/booking");
    } else {
      setRenderType("select");
    }
  };
  //new
  const startBookaSessionLater = (stat) => {
    let body = {
      session_id: localStorage.getItem("session_id"),
      selected_booking_type: "donated",
    };
    saveUserTracksHandler(body);
    setActiveSessionId("5");
    setactivesession_id("5");
    setActiveSubSessionId("");
    localStorage.setItem("activesession_id", "5");
    // getSubsessions(5)
    setBookingType("outreach");
    if (stat === "dummy") {
      setPractitionerInfo(null);
    }
    setcheckOriganalType(stat);
    if (auth.user.terms_session_status === 1) {
      setSaveTerms(auth.user.terms_session_status);
      setRenderType("startBookaSessionLaterQuestions");
    } else {
      setSessionType("later");
      setRenderType("newzoomcodequestions");
    }
  };
  const startBookaSessionLaterVideo = () => {
    // setRenderType("startBookaSessionLaterQuestions");
    setShowBtn(true);
    setShowPopup(true);
    setRenderType("startBookaSessionLaterloader");
    setLoaderType("video");
  };
  const startBookaSessionLaterQuestions = (prof) => {
    if (sessionType === "prof") {
      setRenderType("book-specific-professinal");
    } else {
      // setShowBtn(true);
      let body = {
        session_id: localStorage.getItem("session_id"),
        watch_video: "yes",
      };
      saveUserTracksHandler(body);

      if (bookingType == "starter") {
        setRenderType("questions-starter");
      } else {
        setRenderType("startBookaSessionLaterQuestions");
      }
    }
    // setShowBtn(true);
    // setLoaderType("image");
  };
  const refreshpage = () => {
    let body = {
      session_id: localStorage.getItem("session_id"),
      booking_page_back_btn_clicked: "yes",
    };
    saveUserTracksHandler(body);
    localStorage.removeItem("session_id");
    navigate("/appointments");
  };
  const getSubsessions = (id, sub_session_id, duration, amount, currency) => {
    console.log(id, "id main");
    let info = id.map((item) => {
      return {
        duration: item.duration,
        id: item.subsession_id,
        pricing_type: "free",
        sub_session_name: item.name,
        price: item.price,
        currency: item.currency,
      };
    });
    // getCreateAppointmentSubseesions(7)
    //   .then((data) => {
    // if (data.data.status) {
    console.log(info, "infodetails");
    // setActiveSubSessionId
    // if (data.data.data.length) {

    setActiveSubSessionId(sub_session_id !== undefined ? sub_session_id : "");
    setActiveDurationId(duration !== undefined ? duration : "");
    setActiveAmount(amount !== undefined ? amount : "20");
    setActiveCurrency(currency !== undefined ? currency : "USD");
    localStorage.setItem(
      "subsession_id",
      sub_session_id !== undefined ? sub_session_id : ""
    );
    localStorage.setItem("duration", duration !== undefined ? duration : "");
    localStorage.setItem("amount", amount !== undefined ? amount : "20");
    localStorage.setItem(
      "activeCurrency",
      currency !== undefined ? currency : "USD"
    );
    // }
    setAppointmentTyepList(info);
    //   }
    // })
    // .catch(() => { });
  };

  const startProfessionalJourney = () => {
    let body = {
      session_id: localStorage.getItem("session_id"),
      selected_booking_type_second: "pro",
    };
    saveUserTracksHandler(body);
    setBookingType("professional");
    setSessionType("prof");
    setactivesession_id("5");
    auth.user.terms_session_status === 1
      ? startBookaSessionLaterQuestions()
      : setRenderType("startBookaSessionLaterprofessional");
  };

  useEffect(() => {
    let redirect_to = localStorage.getItem("redirect_to");
    if (redirect_to === "starter-booking" && canShowStarterOption) {
      // bookStarterSession();
      setGlowStarterType(true);
    } else {
      setGlowStarterType(false);
    }
    localStorage.removeItem("redirect_to");
  }, [canShowStarterOption]);
  const bookStarterSession = () => {
    if (blockedStarterBooking) {
      toast.error(
        "Starter session booking is not available for your account.",
        {
          position: "top-center",
        }
      );
      clearStarterBookingDraft();
      return;
    }

    if (auth.user.terms_session_starter_status === 1) {
      starterSelectAllQuestions();
    } else {
      setactivesession_id("3");
      setActiveSubSessionId("33");
      localStorage.setItem("activesession_id", "3");
      localStorage.setItem("subsession_id", "33");
      // setRenderType("newappointment");
      setSessionType("later");
      setRenderType("startBookaSessionLater");
      setBookingType("starter");
      localStorage.setItem("type", "newappointment");
      localStorage.removeItem("redirect_to");
    }

    // setActiveDurationId('');
    // setActiveAmount('');
    // setActiveCurrency('');
    // localStorage.setItem('subsession_id', '');
    // localStorage.setItem('duration', '');
    // localStorage.setItem('amount', '20');
    // localStorage.setItem('activeCurrency','');
  };
  const starterSelectAllQuestions = () => {
    setRenderType("starterQuestions");
    // setRenderType("newappointment");
  };
  const startMainStarterBooking = () => {
    if (blockedStarterBooking) {
      toast.error(
        "Starter session booking is not available for your account.",
        {
          position: "top-center",
        }
      );
      clearStarterBookingDraft();
      return;
    }

    setactivesession_id("3");
    setActiveSubSessionId("33");
    localStorage.setItem("activesession_id", "3");
    localStorage.setItem("subsession_id", "33");
    setSessionType("later");
    setRenderType("newappointment");
    setBookingType("starter");
    localStorage.setItem("type", "newappointment");
    localStorage.removeItem("redirect_to");
  };
  const bookStarterSessionVideo = () => {
    if (blockedStarterBooking) {
      toast.error(
        "Starter session booking is not available for your account.",
        {
          position: "top-center",
        }
      );
      clearStarterBookingDraft();
      return;
    }

    let body = {
      session_id: localStorage.getItem("session_id"),
      selected_booking_type_second: "starter",
    };
    saveUserTracksHandler(body);
    if (auth.user.is_starter_video_displayed === 0) {
      setRenderType("one-time-starter-session-video");
    } else {
      bookStarterSession();
    }
  };
  const bookExtraServices = () => {
    let guest_id = localStorage.getItem("guest_id");
    // navigate(`/guest-booking/${guest_id}`);
    navigate(`/guest-booking/${process.env.REACT_APP_USER_ID}`);

    // getMediumServiceDetails(3711)
    // .then((data) => {
    //   if (data.data.status) {
    //     setMediumSessionInfo(data.data.data[0]);
    //     console.log('abc',mediumSessionInfo)
    //   }
    // })
    // .catch(() => { });
    // setactivesession_id('12')
    // setActiveSubSessionId('80');
    // localStorage.setItem('activesession_id', '12');
    // localStorage.setItem('subsession_id', "80")
    // setSessionType("later");

    // if (auth.user.terms_session_starter_status === 1) {
    //   setRenderType("newappointment");
    // }
    // else {
    //   setRenderType("startBookaSessionLater");

    // }
    // setBookingType('outreach');
    // localStorage.setItem("type", "newappointment");
  };
  const openBackfillpopup = (type) => {
    let body = {
      session_id: localStorage.getItem("session_id"),
      terms_checked: "yes",
    };
    saveUserTracksHandler(body);

    const { country, language } = buildMatchingCriteria(auth.user);

    immediateOnDemandRealtime
      .checkQueueAvailability({ country, language })
      .then((data) => {
        if (data && data.available) {
          // A medium is sitting in the on-demand queue right now — ask the
          // client if they want us to check for them.
          setRenderType("backfillPopup");
          setBackUpRenderType(type);
        } else {
          // No medium currently in queue — skip the popup entirely and go
          // straight to the normal scheduling flow.
          setRenderType(type);
        }
      })
      .catch(() => {
        // If the availability check itself fails, fall back to previous
        // behaviour rather than blocking the booking flow.
        setRenderType("backfillPopup");
        setBackUpRenderType(type);
      });
  };
  const closeBackFillPopup = () => {
    if (bookingType == "outreach") {
      let body = {
        session_id: localStorage.getItem("session_id"),
        available_medium_option: "no",
      };
      saveUserTracksHandler(body);
      setRenderType(backupRenderType);
    } else {
      getPractitionarsList();
    }
  };

  const openBackFillPopup = () => {
    let body = {
      session_id: localStorage.getItem("session_id"),
      available_medium_option: "yes",
    };
    saveUserTracksHandler(body);
    // go-on-demand-client
    navigate("/go-on-demand-immediate-session?skip_confirm=true");
  };
  const backToSelectBoxHandler = () => {
    let bookingFrom = localStorage.getItem("bookingFrom");
    if (bookingFrom === "medium" || bookingFrom === "removed") {
      localStorage.removeItem("bookingFrom");
      navigate("/service-entry");
    } else if (bookingFrom) {
      navigate("/booking");
    } else {
      setRenderType("select");
    }
  };
  const saveUserTracksHandler = (body) => {
    saveUserTracks(body)
      .then(() => {})
      .catch(() => {});
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const from = params.get("from");

    if (from === "coach-reviews") {
      console.log("2601");
      // Favorite Mediums hands off here via ?from=coach-reviews, but never
      // goes through startProfessionalJourney() - so bookingType was staying
      // at its default "" all the way to Progress/index.js's
      // checkBookingType(), which only runs the Pay to Book / Pay It Forward
      // gate when bookingType === "professional". With it unset, every
      // booking made from Favorite Mediums fell through to the generic
      // `else { bookAppointment(); }` branch and skipped payment entirely,
      // even for Pay to Book mediums. sessionType/activesession_id already
      // default to the same "prof"/"5" values startProfessionalJourney sets,
      // so bookingType was the only one actually missing.
      setBookingType("professional");
      setRenderType("premium-session-new");
      //setRenderType("newappointment");// 👈 Call your function here
    }
  }, [location.search]);
  return (
    <div>
      {renderType === "starterQuestions" && (
        <StarterQuestions
          onCancelQuestions={() => setRenderType("select")}
          onForward={startMainStarterBooking}
        />
      )}
      {renderType === "one-time-starter-session-video" && (
        <StarterVideoOneTimeWatch
          backHandler={backHandler}
          onVideoEnd={bookStarterSession}
        />
      )}
      {renderType === "premium-session" && (
        <Practitioners
          specialtyData={specialtyData}
          languages={formLanguages}
          practitioners={practitioners}
          isListLoading={practitionersLoading}
          onClick={bookSession}
          back={() => backToSelectBoxHandler()}
          getPractitionarFiltersList={getPractitionarFiltersList}
          startBookaSessionLaterVideo={startBookaSessionLaterVideo}
          setBookInfo={setPractitionerInfo}
          startBookaSessionLaterQuestions={startBookaSessionLaterQuestions}
          saveterms={saveterms}
          getSubsessions={getSubsessions}
          setRenderType={setRenderType}
          onToggleFavorite={toggleFavoriteHandler}
          canFavorite={canFavorite}
          favoritePendingId={favoritePendingId}
        />
      )}
      {renderType === "premium-session-new" && (
        <PractitionersMain
          specialtyData={specialtyData}
          languages={formLanguages}
          practitioners={practitioners}
          onClick={bookSession}
          back={() => backToSelectBoxHandler()}
          getPractitionarFiltersList={getPractitionarFiltersList}
          startBookaSessionLaterVideo={startBookaSessionLaterVideo}
          setBookInfo={setPractitionerInfo}
          startBookaSessionLaterQuestions={startBookaSessionLaterQuestions}
          saveterms={saveterms}
          getSubsessions={getSubsessions}
          setRenderType={setRenderType}
          onToggleFavorite={toggleFavoriteHandler}
          canFavorite={canFavorite}
          favoritePendingId={favoritePendingId}
        />
      )}

      {renderType === "book-a-session" && (
        <PractitionerInfo
          PractitionerInfo={practitionerInfo}
          onClick={() => setRenderType("premium-session")}
          setRenderType={setRenderType}
          startBookaSessionLaterVideo={startBookaSessionLaterVideo}
          startBookaSessionLaterQuestions={startBookaSessionLaterQuestions}
          setBookInfo={setPractitionerInfo}
          getSubsessions={getSubsessions}
          onToggleFavorite={toggleFavoriteHandler}
          canFavorite={canFavorite}
          isTogglingFavorite={
            practitionerInfo &&
            practitionerInfo.general &&
            favoritePendingId === practitionerInfo.general.medium_id
          }
        />
      )}
      {renderType === "book-specific-professinal" && (
        <StepTwo
          onCancelQuestions={onCancelQuestions}
          // onCancelQuestions={() => setRenderType("premium-session")}
          practitionerInfo={practitionerInfo}
          setRenderType={setRenderType}
          bookInfo={bookInfo}
          setSaveTerms={setSaveTerms}
          getSessionTerms={getSessionTerms}
          bookingType={bookingType}
          getSubsessions={getSubsessions}
          activeSessionId={activeSessionId}
          // StepTwo calls this once the professional checklist is submitted.
          // Normally that means "now show the medium list"; when the client came
          // from favourites the medium is already chosen, so it opens the
          // calendar for them instead.
          getPractitionarsList={
            favoriteBooking ? finishFavoriteBooking : getPractitionarsList
          }
          activesession_id={activesession_id}
          openBackfillpopup={openBackfillpopup}
        />
      )}
      {renderType === "startBookaSessionLater" && (
        <StepOne
          onCancelQuestions={onCancelQuestions}
          startLoaderNow={startBookaSessionLaterVideo}
        />
      )}
      {renderType === "startBookaSessionLaterprofessional" && (
        <StepOne
          onCancelQuestions={onCancelQuestions}
          startLoaderNow={startBookaSessionLaterVideo}
        />
      )}

      {renderType === "newzoomcodequestions" && (
        <DonatedBookingQuestion
          onCancelQuestions={onCancelQuestions}
          startLoaderNow={startBookaSessionLaterVideo}
          saveUserTracksHandler={saveUserTracksHandler}
        />
      )}
      {renderType === "startBookaSessionLaterloader" && (
        <div>
          {/**true for live and false for staging */}
          <Loader
            showBtn={true}
            disabled={showBtn}
            backHandler={backHandler}
            onVideoEnd={startBookaSessionLaterQuestions}
            loaderType={loaderType}
            text="Please turn up your volume to watch this 3-minute introductory video"
            setRenderType={setRenderType}
            bookingType={bookingType}
            activesession_id={activesession_id}
          />
        </div>
      )}
      {renderType === "startBookaSessionLaterQuestions" && (
        <StepTwo
          onCancelQuestions={onCancelQuestions}
          setRenderType={setRenderType}
          getSessionTerms={getSessionTerms}
          url={checkOriganalType === "dummy" ? undefined : false}
          setSaveTerms={setSaveTerms}
          saveterms={auth.user.terms_session_status}
          bookingType={bookingType}
          activesession_id={activesession_id}
          openBackfillpopup={openBackfillpopup}
        />
      )}
      {console.log(renderType, "renderTyperenderTyperenderTyperenderType")}
      {renderType === "select" && (
        <div>
          <div className="select-appointment">
            <div className="container">
              <div className="back-btn-appointments mb-3 d-block width-unset">
                <div onClick={refreshpage} className="bck pointer">
                  <img src="images/black-erow.png" alt="back" />
                  <p className="margin-unset"> Back</p>
                </div>
              </div>
              <div className="select-appointment-inner width-unset">
                {/* <div  data-toggle="modal"

                data-target="#setPreferenceModal" className="edite">
                  <a href="">
                    Edit Preferences
                    <img src="images/pencil.png" />
                  </a>
                </div> */}
                {parseInt(bannerLimit) === 1 && (
                  <h2 className="banner-stop-text">{bannerDesc}</h2>
                )}
                <div className="appointment-area-white vs-booking-panel">
                  <div className="appointment-text-tab vs-booking-mission">
                    <p className="vs-booking-mission-label">
                      Our mission is simple…
                    </p>
                    <h1 className="vs-booking-mission-heading">
                      Trustworthy mediumship, for everyone.
                    </h1>
                    <p className="vs-booking-mission-copy">
                      Every session booked here helps us keep the door open for
                      all.
                    </p>
                  </div>
                  <h2 className="vs-booking-title">Select Appointment Type</h2>
                  <h3 className="vs-booking-title-text">
                    Professional sessions start at $50 — and every dollar goes
                    straight to your medium.
                  </h3>
                  {is_starter !== undefined &&
                    is_starter === 1 &&
                    appointmentCount == 0 &&
                    starter_user_survey == 1 && (
                      <h3 className="do-a-session-note-new vs-booking-subtitle">
                        Please book a session from one of the options below.
                      </h3>
                    )}

                  <div className="vs-booking-cards">
                    <article
                      className="vs-booking-card vs-booking-card-professional"
                      onClick={startProfessionalJourney}
                      onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                          event.preventDefault();
                          startProfessionalJourney();
                        }
                      }}
                      role="button"
                      tabIndex={0}
                    >
                      <div className="vs-booking-badge">Recommended</div>
                      <div className="vs-booking-card-art">
                        <img src="localImages/p1.png" alt="do a session" />
                      </div>
                      <h5 className="vs-booking-card-title">Professional</h5>
                      <p className="vs-booking-card-subtitle">
                        Choose your own medium.
                      </p>

                      <div className="vs-booking-card-body">
                        <ul className="vs-booking-card-list">
                          <li>
                            Hand-pick your medium — browse profiles & reviews
                          </li>
                          <li>Book a time today — whenever works for you</li>
                          <li>Experienced, fully-vetted mediums</li>
                          <li>
                            100% goes to your medium — we charge no platform fee
                          </li>
                        </ul>
                        <h3 className="do-a-session-note-new vs-booking-title-text">
                          Sessions start at $50 USD
                        </h3>
                        <h3 className="do-a-session-note-new vs-booking-title-text">
                          Booking here helps us gather reviews and ensure high
                          quality.
                        </h3>
                        <button
                          type="button"
                          className="vs-booking-card-button"
                        >
                          Book My Pro Session
                        </button>
                      </div>
                    </article>

                    {canShowDonatedOption && (
                      <article
                        className="vs-booking-card vs-booking-card-donated"
                        onClick={() => canUseImmediateSession ? window.loadModal2("#ConfirmImmediateSessionAppt", "show") : startBookaSessionLater("dummy")}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            canUseImmediateSession ? window.loadModal2("#ConfirmImmediateSessionAppt", "show") : startBookaSessionLater("dummy");
                          }
                        }}
                        role="button"
                        tabIndex={0}
                      >
                        <div className="vs-booking-card-art">
                          <img src="localImages/p2.png" alt="do a session" />
                        </div>
                        <h5 className="vs-booking-card-title">Donated</h5>
                        <p className="vs-booking-card-subtitle">
                          For those who can't afford to pay.
                        </p>
                        <div className="vs-booking-card-body">
                          <ul className="vs-booking-card-list">
                            <li>Free of charge — one booking per person</li>
                            <li>
                              A medium is assigned to you when one is available
                            </li>
                            <li>Sessions with caring, up-&-coming mediums</li>
                            <li>
                              A limited number of donated sessions open each
                              month
                            </li>
                          </ul>
                          <button
                            type="button"
                            className="vs-booking-card-button"
                          >
                            {canUseImmediateSession ? "Get Immediate Session" : "Request Donated Session"}
                          </button>
                        </div>
                      </article>
                    )}

                    {canShowStarterOption && (
                      <article
                        className={`vs-booking-card vs-booking-card-starter ${
                          glowStarterType
                            ? "alerts-border outline-offset-5px"
                            : ""
                        }`}
                        onClick={bookStarterSessionVideo}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            bookStarterSessionVideo();
                          }
                        }}
                        role="button"
                        tabIndex={0}
                      >
                        <div className="vs-booking-card-art">
                          <img
                            src="localImages/vs-booking-badge-new.jpg"
                            alt="starter session"
                          />
                        </div>
                        <h5 className="vs-booking-card-title">
                          Starter Volunteer
                        </h5>
                        <p className="vs-booking-card-subtitle">
                          Help our newer mediums grow.
                        </p>
                        <div className="vs-booking-card-body">
                          <ul className="vs-booking-card-list">
                            <li>
                              Get matched with more recently qualified mediums
                            </li>
                            <li>
                              Unlimited free sessions — our thanks for your role
                            </li>
                            <li>
                              In return: arrive on time, rarely cancel, and
                              share thoughtful written feedback
                            </li>
                            <li>
                              By invitation, for clients who’ve already had a
                              great session with us
                            </li>
                          </ul>
                          <button
                            type="button"
                            className="vs-booking-card-button"
                          >
                            Book My Starter Session
                          </button>
                        </div>
                      </article>
                    )}
                  </div>

                  {promotion_code !== null &&
                    promotion_code.toLowerCase() === "supportwga" && (
                      <p className="wga-members-text">
                        <span> WGA Members:</span> Please feel free to book a
                        free Donated Session regardless of your ability to pay
                      </p>
                    )}
                </div>
                <div className="vs-booking-heart">
                  <h2>The Heart of VerySoul</h2>
                  <p>
                    Every session you book with us, and the honest reflection
                    you leave after, makes the next one better for you, for the
                    next person, and for our member mediums.
                  </p>
                  <div className="vs-booking-heart-stage">
                    <svg
                      className="vs-booking-heart-bg"
                      viewBox="0 0 32 29.6"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path d="M23.6,1c-3.4,0-6.3,2.7-7.6,5.6C14.7,3.7,11.8,1,8.4,1C3.8,1,0,4.8,0,9.4c0,9.4,9.5,11.9,16,21.2c6.1-9.3,16-12.1,16-21.2C32,4.8,28.2,1,23.6,1z" />
                    </svg>
                    <div className="vs-booking-heart-grid">
                      <article>
                        <span className="vs-booking-heart-icon">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                          >
                            <path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 9 9 0 0 1-4-1L3 20l1-5.5a8.5 8.5 0 0 1 5-13 8.38 8.38 0 0 1 12 9z" />
                            <path d="M8.5 12l2 2 4.5-4.5" />
                          </svg>
                        </span>
                        <h3>Feedback that ensures high quality</h3>
                        <p>
                          Your honest reflection after each session helps
                          mediums continue to deepen their mastery, ensuring
                          every session is even better than the last.
                        </p>
                      </article>
                      <article>
                        <span className="vs-booking-heart-icon">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                          >
                            <path d="M12 2l2.4 6.9H22l-5.8 4.3 2.2 7L12 16.9 5.6 20.2l2.2-7L2 8.9h7.6z" />
                          </svg>
                        </span>
                        <h3>Trust that reassures the uncertain</h3>
                        <p>
                          Each shared experience builds the trust that gives
                          others the confidence to reach out for the very first
                          time.
                        </p>
                      </article>
                      <article>
                        <span className="vs-booking-heart-icon">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                          >
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
                          </svg>
                        </span>
                        <h3>Access that stays open to all</h3>
                        <p>
                          A thriving community lets us offer donated sessions
                          and a trusted place to find a medium, keeping this
                          within reach of everyone who needs it.
                        </p>
                      </article>
                    </div>
                  </div>
                </div>
                <div className="vs-booking-signature">
                  <p>Helping you feel the love that's never left.</p>
                  {/* <span>Evidence &middot; Inspiration &middot; Empowerment</span> */}
                </div>
                <div className="vs-booking-signature vs-booking-additional">
                  <div className="container">
                    <div className="vs-booking-additional-keywords">
                      <span>Evidence</span>
                      <span className="dot">◆</span>
                      <span>Inspiration</span>
                      <span className="dot">◆</span>
                      <span>Empowerment</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <Progress
            loaderLine={time}
            setAppointments={setAppointments}
            changeRender={changeRender}
            getAvailabilites={() => {}}
            selectType={"loader"}
          /> */}
        </div>
      )}
      {renderType === "loader" && (
        <div>
          <Loader
            backHandler={() => backToSelectBoxHandler()}
            onVideoEnd={onVideoEnd}
            loaderType={loaderType}
            text="Please turn up your volume to watch this 3-minute introductory video"
          />
        </div>
      )}
      {renderType === "questions" && (
        <Questions
          bookingType={bookingType}
          onCancelQuestions={onCancelQuestions}
          startLoaderNow={startLoaderNow}
        />
      )}
      {renderType === "questions-starter" && (
        <QuestionsStarter
          onCancelQuestions={onCancelQuestions}
          setRenderType={setRenderType}
          getSessionTerms={getSessionTerms}
          url={checkOriganalType === "dummy" ? undefined : false}
          setSaveTerms={setSaveTerms}
          saveterms={auth.user.terms_session_status}
          bookingType={bookingType}
          activesession_id={activesession_id}
          openBackfillpopup={openBackfillpopup}
        />
      )}
      {renderType === "render" && (
        <div className="select-appointment">
          <div className="container">
            <div className="book-practice-guest-saction">
              {auth.mediumdata.map((item) => (
                <div className="practice-guest-box">
                  <div className="profile-boxx">
                    <div className="profile-imgg">
                      <img src="images/pr-image.png" alt="profile" />
                    </div>
                    <div className="profile-contt">
                      <span>{item.first_name}</span>
                      <div className="rating">
                        <img src="images/star.png" alt="stars" />
                        <img src="images/star.png" alt="stars" />
                        <img src="images/star.png" alt="stars" />
                        <img src="images/star.png" alt="stars" />
                        <img src="images/star.png" alt="stars" />
                        <em>25 Reviews</em>
                      </div>
                    </div>
                  </div>

                  <div className="profile-boxx-lest">
                    <ul>
                      <li>
                        <div className="icon-gest">
                          <img src="images/badg-new.png" alt="mediums" />
                        </div>
                        Mediumship Specialities:<span>None in Particular</span>
                      </li>
                      <li>
                        <div className="icon-gest">
                          <img src="images/languag-new.png" alt="languages" />
                        </div>
                        Languages:<span>English,Catalan</span>
                      </li>
                      <li>
                        <div className="icon-gest">
                          <img src="images/globe-new.png" alt="country" />
                        </div>
                        Country:<span>United States</span>
                      </li>
                    </ul>
                    <div className="dont-have-acc gust-ppop">
                      <button
                        type="button"
                        className="btn btn-info btn-lg"
                        data-toggle="modal"
                        data-target="#myModal2"
                      >
                        Select
                      </button>
                      <div className="modal fade" id="myModal2" role="dialog">
                        <div className="modal-dialog modal-dialog-preview">
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                          >
                            &times;
                          </button>
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="guest-popup">
                                {/* <img src="images/sadu.png" /> */}
                                <h3>
                                  We are sorry
                                  <br />
                                  there are no Mediums available at the moment.
                                </h3>
                                <a href="#">Book an advance session</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {renderType === "newappointment" && (
        <>
          {" "}
          <AdvanceAppointment
            practitionerInfo={practitionerInfo}
            sessionType={sessionType}
            appointmentTyepList={appointmentTyepList}
            activeSubSessionId={activeSubSessionId}
            activeDurationId={activeDurationId}
            getSubsessions={getSubsessions}
            setActiveSubSessionId={setActiveSubSessionId}
            setActiveDurationId={setActiveDurationId}
            setActiveAmount={setActiveAmount}
            setActiveCurrency={setActiveCurrency}
            activeAmount={activeAmount}
            activeCurrency={activeCurrency}
            activesession_id={activesession_id}
            bookingType={bookingType}
            // handleStart={handleStart}
            // handleReset={handleReset}
          />
          <Progress
            bookingType={bookingType}
            sessionType={sessionType}
            practitionerInfo={practitionerInfo}
            loaderLine={time}
            setAppointments={setAppointments}
            changeRender={changeRender}
            getAvailabilites={getAvailabilites}
            selectType={"newappointment"}
            bookAppointment={bookAppointment}
            activeSubSessionId={activeSubSessionId}
            activeAmount={activeAmount}
            activeDurationId={activeDurationId}
          />
        </>
      )}
      {renderType === "backfillPopup" && (
        <BackFillCheck
          closeBackFillPopup={closeBackFillPopup}
          openBackFillPopup={openBackFillPopup}
        />
        // <StepOne
        //   onCancelQuestions={onCancelQuestions}
        //   startLoaderNow={startBookaSessionLaterVideo}
        // />
      )}
      <div className="text-center for-support-text">
        <p className="mt-3 nav-link font-size-22 ">
          For Support &nbsp;
          <a href={process.env.REACT_APP_SUPPORT_URL} target="_blank">
            Click Here
          </a>
        </p>
        {/* <p>Click here for <Link to={'/intro-video'}> introductory video</Link></p> */}
      </div>
      <Footer />
      <ConfirmImmediateSession
        id="ConfirmImmediateSessionAppt"
        deleteUser={() => {
          window.loadModal2("#ConfirmImmediateSessionAppt", "hide");
          navigate("/go-on-demand-immediate-session");
        }}
        cancelRequest={() => window.loadModal2("#ConfirmImmediateSessionAppt", "hide")}
      />
      {console.log(bookingType, "bookingType", "bookingType")}
      <div className="dont-have-acc gust-ppop">
        <div
          className="modal fade"
          id="myModal2"
          role="dialog"
          data-backdrop="static"
        >
          <div className="modal-dialog modal-dialog-preview">
            {/* <button type="button" className="close" data-dismiss="modal">
              &times;
            </button> */}
            <div className="modal-content">
              <div className="modal-body mt-3">
                <div className="guest-popup mt-5">
                  {/* <img src="images/sadu.png" /> */}
                  <h3>
                    Would you like to continue to wait for
                    <br />a session?
                  </h3>

                  <div className="cancel-btn-check-popup-wraper">
                    <Button
                      className={"try-again-book-btn"}
                      status={0}
                      onClick={() => startBookingAgain()}
                      title="Yes, Continue to Wait"
                    />
                    <Button
                      className={"cancel-btn-check-popup"}
                      status={0}
                      onClick={() => bookNewAppointment()}
                      title="No, Try to book a different session"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dont-have-acc gust-ppop">
        <div className="modal fade" id="noslotsfound" role="dialog">
          <div className="modal-dialog modal-dialog-preview">
            <button
              type="button"
              className="close pointer"
              data-dismiss="modal"
            >
              &times;
            </button>
            <div className="modal-content">
              <div className="modal-body">
                <div className="guest-popup">
                  {/* <img src="images/sadu.png" /> */}
                  <h3>
                    We are sorry
                    <br />
                    there are no slots available at the moment.
                  </h3>
                  <a
                    data-dismiss="modal"
                    onClick={() => {
                      navigate("/appointments");
                      window.location.reload();
                    }}
                    href="javascript:void(0);"
                  >
                    My Appointments
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AboutReviewModal />
      <div className="join-box-meet">
        <OpenUrlPopUp url={redirelUrl} />
      </div>
    </div>
  );
}
